import { applyPageSeo } from "../lib/seo";
import type { Locale } from "../types";

type StaticPageProps = {
  title: string;
  body: string[];
  locale: Locale;
  pathname: string;
};

export function StaticPage({ title, body, locale, pathname }: StaticPageProps) {
  applyPageSeo({
    title: `${title} - TextPolish Tools`,
    description: body[0] || title,
    locale,
    path: pathname
  });

  return (
    <main className="static-page" id="main-content">
      <h1>{title}</h1>
      {body.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </main>
  );
}
